// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"searchPage_searchPage__19-E_","container":"searchPage_container__11Jkj","contentWrapper":"searchPage_contentWrapper__1mcmo","content":"searchPage_content__1G2zt"};